import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn, useTranslation } from '@supply-mover-2-0/web-ui';
import type { JSX } from 'react';

/**
 * PD-17299 — what the customer can do about a bank payment their bank sent
 * back, shown where the payment or the bank account is shown. Today that is
 * only an R29 return: the bank blocked the debit, and allowing the company
 * ID it names lets the next one through.
 *
 * The text comes from the server, already worded for the customer and free
 * of the processor's name; this only gives it the storefront's warning look,
 * so the transactions list, the payment page and the wallet show it alike.
 * PD-17697 — the wallet also shows the notice for a bank account whose
 * recent payments came back through it. Renders nothing without an
 * instruction, which is the normal case.
 */
export function AchReturnInstructionNotice({
	instruction,
	className,
}: {
	instruction: string | null | undefined;
	className?: string;
}): JSX.Element | null {
	const { t } = useTranslation();

	if (instruction == null || instruction === '') {
		return null;
	}

	return (
		<div
			role="status"
			className={cn(
				'flex items-start gap-2 text-xs rounded-lg px-3 py-2 bg-warning-badge text-warning-tint-fg border border-warning-tint',
				className,
			)}
		>
			<FontAwesomeIcon icon={faTriangleExclamation} className="mt-0.5 shrink-0" />
			<span>{t(instruction)}</span>
		</div>
	);
}
